var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconCrownColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M22.5 18.75h-20L1.875 8.125l5 3.75L12.5 6.25l5.625 5.625 5-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M22.5 21.25h-20v-2.5h20v2.5zm-10-15c.688 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25zm11.25 1.875c.688 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25zm-22.5 0c.688 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25z"
  }))));
}

export default SvgCommonIconCrownColor;